import { useState, createContext, useEffect } from "react";
import {
  ISiteUsersTableReport,
  ISiteUsersTableSearchParam,
} from "../../Interfaces/siteUserInterfaces";
import { getSiteUsersTable } from "../../Requests/siteUserRequests";
import TableTemplate from "../TableTemplate/tableTemplate";
import { SiteUsersTableUI } from "./SiteUsersTableUI";
import TextInput from "../../Components/TextInput";
import CheckBox from "../../Components/Checkbox";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { useDebouncer } from "../../Hooks/useDebouncer";
import { getRoles } from "../../Requests/roleAndPermissionsRequests";

interface IProps {
  tableRefreshFlag: boolean;
  setTableRefreshFlag: (flag: boolean) => void;
}

export const SiteUserTableContext = createContext({
  tableRefreshFlag: false,
  setTableRefreshFlag: (flag: boolean) => {},
});

const SiteUserTable = ({ setTableRefreshFlag, tableRefreshFlag }: IProps) => {
  const [searchParams, setSearchParams] = useState({
    justActive: true,
    showCustomerRole: false,
    roleId: null,
  } as ISiteUsersTableSearchParam);

  const [searchParamName, setSearchParamName] = useState("");
  const name = useDebouncer(searchParamName, 300);

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  useEffect(() => {
    setSearchParams((current) => ({ ...current, name }));
  }, [name]);

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <div className="flex flex-col justify-start items-start gap-3 mx-auto">
        <div className="flex flex-row flex-wrap justify-center items-end gap-2">
          <div className="w-48">
            <TextInput
              label="نام"
              name="name"
              onChange={(_, value) => setSearchParamName(value)}
              value={searchParamName}
              autoComplete="off"
              extraLabel
            />
          </div>

          <div className="w-48">
            <DynamicDropdown
              dropdown={{
                name: "roleId",
                placeholder: "نقش",
                extraLabel: true,
              }}
              getData={getRoles}
              onChange={changeHandler}
              value={searchParams.roleId ?? null}
            />
          </div>

          <CheckBox
            checked={searchParams.showCustomerRole}
            label="نمایش نقش مشتری"
            name="showCustomerRole"
            onChange={changeHandler}
          />

          <CheckBox
            checked={searchParams.justActive}
            label="فقط فعال"
            name="justActive"
            onChange={changeHandler}
          />
        </div>
        <SiteUserTableContext.Provider
          value={{ setTableRefreshFlag, tableRefreshFlag }}
        >
          <TableTemplate<ISiteUsersTableSearchParam, ISiteUsersTableReport>
            getDataTable={getSiteUsersTable}
            TableUI={SiteUsersTableUI}
            searchParameters={searchParams}
            initialSearchParameters={searchParams}
          />
        </SiteUserTableContext.Provider>
      </div>
    </div>
  );
};

export default SiteUserTable;
